import {SpecificationType} from "../../definitions/types";
import {SpecificationModel} from "../domain/specificationModel";

export class SpecificationsModel {
    private readonly _specifications: SpecificationModel[];

    constructor(public readonly specificationTypes: SpecificationType[]) {
        this._specifications = specificationTypes.map(specification => new SpecificationModel(specification));
    }

    /**
     * @method specifications
     * @description Gets the specifications for the model in a 2D array (2 columns) for display purposes
     * @returns {SpecificationModel[][]}
     */
    public get specifications(): SpecificationModel[][] {
        return this._specifications.reduce((resultArray: SpecificationModel[][], specification, index) => {
            const chunkIndex = Math.floor(index / 2);
            if (!resultArray[chunkIndex]) resultArray[chunkIndex] = [];
            resultArray[chunkIndex].push(specification);
            return resultArray
        }, []);
    }

    /**
     * @method count
     * @description Gets the number of specifications for the model
     * @returns {number}
     */
    public get count(): number {
        return this._specifications.length;
    }

    /**
     * @method hasSpecifications
     * @description Returns true if the model has specifications
     * @returns {boolean}
     */
    public get hasSpecifications(): boolean {
        return this.count > 0;
    }
}